import React from "react";

class Loader extends React.Component {
  state = {
    loading: true,
  };
  render() {
    return (
      <div className="spinner_overlay">
        <img
          className="spinner"
          src={require("assets/play365/images/logos/logo.webp")}
        />
      </div>
    );
  }
}

export default Loader;
